module.exports = __webpack_public_path__ + "static/media/01d.5c3e9a84.svg";